import * as R from 'ramda'
import {
  City,
  CityWithKey
} from 'types/typescript'
import {
  GetCityName,
  GetDepartureCitiesFromCode,
  GetStockByCity,
  IsDepartureCityAvailable,
  SortDepartureCityOptions
} from './pricerDepartureCity.types'

export const getCityName: GetCityName = R.curry(
  (allCities: CityWithKey[], cityKey: City['code']) => R.find(
    R.propEq('key', cityKey),
    allCities
  )
)

export const getDepartureCitiesFromCode: GetDepartureCitiesFromCode = cities => R.map(
  (cityCode: City['code']) => getCityName(cities, cityCode).label
)

export const sortDepartureCityOptions: SortDepartureCityOptions = (favoriteDepartureCity, options) => R.sortWith([
  R.descend(R.propEq('key', favoriteDepartureCity)),
  R.ascend(R.prop('label'))
])(options)

export const getStockByCity: GetStockByCity = pickersBindingsStock => (
  pickersBindingsStock?.reduce(
    (acc, stock) => {
      acc[stock.key] = stock.isAvailable
      return acc
    }, {}
  )
)

export const isDepartureCityAvailable: IsDepartureCityAvailable = (departureCity, allCities) => allCities.reduce((acc: boolean, city) => {
  if (!acc && city.stock && city.key === departureCity) {
    acc = true
  }
  return acc
}, false)
